<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="visitForm" label-width="auto" label-position="right">
      <el-form-item label="回访状态：">
        <el-radio-group v-model="visitForm.visitState">
          <el-radio :label="0">未拨打</el-radio>
          <el-radio :label="1">未接通</el-radio>
          <el-radio :label="2">已拨打</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="回访备注：">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10 }" :maxlength="100" placeholder="100字以内" v-model="visitForm.visitRemark"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { updatePreBookVisitState } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      visitForm: this.value.visitForm,
      idx: this.value.ids,
      preId: this.value.preId,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      let param = {}

      param['id'] = this.idx > -1?this.visitForm.id:0;
      param['visitState'] = this.visitForm.visitState;
      param['visitRemark'] = this.visitForm.visitRemark;
      postFormData(updatePreBookVisitState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
